'use client'

import {
  CardGrid,
  Container,
  GlassCard,
  GlassCardBody,
  Reveal,
  Section,
  SectionHeader,
  Stagger,
  ThemeImageClient,
} from 'design-studio'
import {
  SL_GLASS_BODY,
  SL_GLASS_SURFACE,
  SL_GLASS_TITLE,
} from '@/components/theme'

const ARTIFACTS = [
  {
    title: 'Requirements',
    description: 'Reveal intended behavior, constraints, and obligations.',
  },
  {
    title: 'Source code',
    description:
      'Reveals operational behavior, control flow, state changes, and domain logic.',
  },
  {
    title: 'Scenarios',
    description:
      'Capture structured behavioral slices of what is true before, what happens, and what should follow.',
  },
  {
    title: 'Tests and logs',
    description:
      'Provide expected and observed evidence that helps refine the discovered model.',
  },
  {
    title: 'Operational traces',
    description:
      'Add semantic observability by grounding the model in behavior actually seen in production.',
  },
  {
    title: 'Predicates, transitions, and state',
    description:
      'Turn discovered structure into an analyzable model of behavior over time.',
  },
]

export function SectionModelDiscovery() {
  return (
    <Section id="how-it-works" className="relative scroll-mt-19 py-16 sm:py-24">
      <Container className="relative z-10">
        <Stagger className="space-y-10">
          <Reveal className="mx-auto max-w-6xl">
            <SectionHeader
              pretitle="Model discovery"
              pretitleColor="text-teal-500"
              title="How SpecLogician Discovers the Model"
              description="SpecLogician helps LLM coding agents discover states, transitions, predicates, and scenarios from the artifacts that already exist in a project."
            />
          </Reveal>

          <Reveal className="mx-auto flex max-w-7xl flex-col gap-8">
            <ThemeImageClient
              lightSrc="/images/sl-diag-1-light.svg"
              darkSrc="/images/sl-diag-1-dark.svg"
              alt="Diagram showing requirements, scenarios, source code, tests, and logs grounded in the same domain model"
              className="mx-auto w-full max-w-4xl"
              width={1424}
              height={480}
            />

            <CardGrid columns={3} gap="sm">
              {ARTIFACTS.map(({ title, description }) => (
                <GlassCard
                  key={title}
                  title={title}
                  titleClassName={SL_GLASS_TITLE}
                  className={SL_GLASS_SURFACE}
                >
                  <GlassCardBody className={SL_GLASS_BODY}>
                    {description}
                  </GlassCardBody>
                </GlassCard>
              ))}
            </CardGrid>
          </Reveal>
        </Stagger>
      </Container>
    </Section>
  )
}
